'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _inputsStyles = require('../inputsStyles/inputsStyles');
var _styledComponents = require('styled-components');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var handleInputChange = function handleInputChange(input, value, customChange) {
  return function (event) {
    if (customChange) {
      customChange(input, event);
    } else {
      input.onChange(value);
    }
  };
};
var handleInputCheck = function handleInputCheck(inputValue, comparator) {
  if (comparator !== undefined) {
    return comparator(inputValue);
  }
  return inputValue;
};
var CheckBox = function CheckBox(_ref) {
  var customstyle = _ref.customstyle,
    boxColor = _ref.boxColor,
    label = _ref.label,
    onChange = _ref.onChange,
    checked = _ref.checked,
    isRequired = _ref.isRequired,
    disabled = _ref.disabled,
    input = _ref.input,
    id = _ref.id,
    comparator = _ref.comparator,
    name = _ref.name,
    customChange = _ref.customChange,
    theme = _ref.theme,
    labelStyles = _ref.labelStyles;
  return _react2.default.createElement(_inputsStyles.CheckboxContainer, {
    customstyle: customstyle
  }, _react2.default.createElement(_inputsStyles.StyledCheck, {
    'data-testid': 'CheckBox',
    id: name,
    boxColor: boxColor,
    name: name,
    value: id,
    onChange: input ? handleInputChange(input, id, customChange) : onChange,
    checked: input && comparator ? handleInputCheck(input.value, comparator) : checked,
    required: isRequired,
    disabled: disabled || theme.disabled,
    type: 'checkbox'
  }), _react2.default.createElement(_inputsStyles.StyledLabel, {
    htmlFor: name
  }, _react2.default.createElement('span', {
    style: Object.assign({
      marginLeft: '20px'
    }, labelStyles)
  }, label || 'LABEL')));
};
CheckBox.defaultProps = {
  isRequired: false
};
exports.default = (0, _styledComponents.withTheme)(CheckBox);